<template>
  <section v-if="cardProfile" class="user-card">
    <div class="avatar">
      <img :src="cardProfile.avatarSrc" alt="用户头像" />
    </div>
    <div class="info">
      <p class="title">{{ cardProfile.title }}</p>
      <p class="bonus">权益加成: {{ cardProfile.bonusRange }}</p>
    </div>
    <div class="chart-deco">
      <img src="@/assets/image/user_pic.png" alt="" />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchUserCardProfile } from "@/contract/services/stakeService";

export default {
  data() {
    return {
      cardProfile: null,
    };
  },
  computed: {
    ...mapGetters(["accountAddress"]),
  },
  watch: {
    accountAddress: {
      immediate: true,
      handler() {
        this.loadCardProfile();
      },
    },
  },
  methods: {
    async loadCardProfile() {
      if (!this.accountAddress) {
        this.cardProfile = null;
        return;
      }
      try {
        this.cardProfile = await fetchUserCardProfile(this.accountAddress);
      } catch (err) {
        console.error("[UserInfoCard] 加载卡牌信息失败", err);
        this.cardProfile = null;
        throw err;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-card {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 30px 24px;
  padding: 12px 30px;
  border-radius: 30px;
  background: #fead5b;
  box-shadow: 0 4px 20px rgba(254, 173, 91, 0.25);
}

.avatar {
  flex-shrink: 0;
  width: 96px;
  height: 96px;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.3);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 96px;

  .title {
    margin: 0 0 4px;
    font-size: 30px;
    font-weight: normal;
    color: #000000;
  }

  .bonus {
    margin: 0;
    font-size: 24px;
    color: #000000;
  }
}

.chart-deco {
  flex-shrink: 0;

  img {
    display: block;
    width: 48px;
    height: auto;
    object-fit: contain;
  }
}
</style>
